module.exports = __webpack_public_path__ + "static/media/GTWalsheimPro-Bold.8ee87a5a.ttf";